(function ($) {
  'use strict';

  Drupal.behaviors.initializeReContactRequestHelper = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    const url = new URL(window.location.href);
    const urlParameters = new URLSearchParams(url.search);

    const $requestLinks = $(
      `[data-modal-id="${urlParameters.get('open')}-modal"]`
    );

    if (!$requestLinks.length) {
      return;
    }

    $requestLinks.trigger('click');
  }
})(jQuery);
